import React, { Component } from 'react';
import $ from 'jquery';
import './_itemdropdown.css';

export default class ItemDropDown extends Component {
 
show(){ 
    $(".menu-item-container").slideUp()
    $(this.menu).slideDown();
    $(document).unbind('click').click(()=>$(".menu-item-container").slideUp())
}

render() {

    const { image, label, hint } = this.props;

    return (
        <div className="menu-item-wrapper">
            <span className="menu-item-title" onClick={this.show.bind(this)} title={hint}>
                { image&&<img src={image} width="16" height="14" /> }
                <span>{label}</span>
            </span>
                <div className="menu-item-container"
                    ref={(element)=>this.menu = element}
                >
                    {
                        this.props.options.map((op, key)=>{
                            return(
                                <li
                                    onClick={()=>this.props.onClickOption(op)}
                                    className="dd-list-item" key={key}>
                                    {op.label}
                                </li>
                            )
                        })
                    }
                </div>
        </div>
        );
    }
}

ItemDropDown.defaultProps = {
    options : [],
    onClickOption : ()=>{},
    label : "",
    hint : "Alterar"
}


// WEBPACK FOOTER //
// ./src/components/itemdropdown/ItemDropDown.js